import { Box, BoxProps } from "@chakra-ui/react";

export function CourseMemberIcon({
  color = "currentColor",
  ...props
}: BoxProps & { color?: string }) {
  return (
    <Box {...props}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="100%"
        height="100%"
        viewBox="0 0 12 16"
        fill="currentColor"
      >
        <path
          d="M11.3333 14.6674H2.33333C1.41286 14.6674 0.666668 13.9212 0.666668 13.0007M0.666668 13.0007V7.12314C0.666668 5.1334 0.666668 4.13853 1.17108 3.4397C1.33812 3.20828 1.54122 3.00518 1.77264 2.83814C2.47147 2.33373 3.46634 2.33373 5.45609 2.33373C6.10701 2.33373 6.89974 2.36803 7.55718 2.37692C8.15668 2.38503 8.45643 2.38908 9.01478 2.29041C9.57312 2.19174 9.63279 2.16905 9.75213 2.12368C10.2655 1.92849 10.7515 1.62493 11.3333 1.33398V7.66741C11.3333 8.90992 11.3333 9.53117 11.1303 10.0212C10.8597 10.6746 10.3406 11.1938 9.68716 11.4644C9.1971 11.6674 8.57585 11.6674 7.33333 11.6674H2C1.26362 11.6674 0.666668 12.2644 0.666668 13.0007Z"
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M10 11.334L10 14.6673"
          stroke="currentColor"
          stroke-linejoin="round"
        />
        <path
          d="M3.33333 2.66602L3.33333 5.33268"
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </Box>
  );
}
